module.exports = __webpack_public_path__ + "img/DnsOutlined.ab1e737d.svg";